import enums from "../enums";
import Service from "../service/index.jsx";

export const getAllContainers = (params) => async (dispatch) => {
	try {
		const response = await Service.get("content-api", "container", { params });

		const filteredContainers = response.data.map((container) => {
			if (container.banners && container.banners.length > 0) {
				const filteredBanners = container.banners.filter((banner) => {
					const currentTime = new Date().getTime();

					if (banner.enabledExpireTime && banner.startTime && banner.endTime) {
						return currentTime >= banner.startTime && currentTime <= banner.endTime;
					}

					return true;
				});

				return {
					...container,
					banners: filteredBanners,
				};
			}

			return container;
		});

		dispatch({
			type: enums.CONTAINER_CONTENT,
			payload: filteredContainers,
		});
	} catch (error) {
		console.error("Error fetching containers:", error);
	}
};
